<div class="multi-select" (mouseleave)="showDropDown && shareCheckedlist()" (click)="focusSel()">
    <button class="drop-toggle btn flat" [disabled]="isDisabled" (click)="showDropDown=!showDropDown" [ngClass]="{'active': showDropDown}">
        <span>検査分類 ({{checkNum}})</span>
        <i class="fa fa-caret-down arr-pading" aria-hidden="true"></i>
    </button>
    <div class="drop-show " [ngClass]="{'scroll-box': items.length >=10}" *ngIf="showDropDown">
        <div *ngFor="let it of items; index as i">
            <label class="custom-checkbox">
                {{it.name}}
                <input type="checkbox" [(ngModel)]="it.check" (click)="checkItem(i)"/>
                <span class="checkmark"></span>
            </label>
        </div>
    </div>
</div>